import { useEffect } from 'react';

interface HotjarProps {
  hjid: number;
  hjsv: number;
}

/**
 * Component to initialize Hotjar tracking
 *
 * @param hjid - Hotjar ID
 * @param hjsv - Hotjar script version
 */
const Hotjar = ({ hjid, hjsv }: HotjarProps) => {
  useEffect(() => {
    // Initialize Hotjar
    (function (h: any, o: any, t: any, j: any, a?: any, r?: any) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid, hjsv };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }, [hjid, hjsv]);

  // This component doesn't render anything
  return null;
};

export default Hotjar;
